import React from 'react';
import styles from './Chip.module.css';
import { Body, BodyColor, BodyType, Heading, TypographyColor, TypographyType } from '..';

interface ChipProps {
    label: string;
    onClick?: () => void;
    icon?: React.ReactNode;
    iconUrl?: string;
    selected?: boolean;
    disabled?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

export const Chip: React.FC<ChipProps> = ({
    label,
    onClick,
    icon,
    iconUrl,
    selected = false,
    disabled = false,
    className = '',
}) => {
    const chipClass = `${styles.chip} ${selected ? styles.selected : ''} ${disabled ? styles.disabled : ''} rounded padding-left-2 padding-right-3 padding-top-bottom-1 gap-1 height-3vh ${className}`;

    const renderIcon = () => {
        if (icon) return <span className={`${styles.icon}`}>{icon}</span>;
        if (iconUrl) return <img src={iconUrl} alt="chip-icon" className={styles.iconImage} />;
        return null;
    };

    return (
        <div
            className={chipClass}
            onClick={() => {
                if (!disabled && onClick) onClick();
            }}
        >
            {renderIcon()}
            {selected ?
                <Heading
                    title={label}
                    type={TypographyType.h6}
                    colour={TypographyColor.primary}
                    classname="text-nowrap"
                /> :
                <Body
                    color={BodyColor.secondary}
                    type={BodyType.p3}
                    classname="text-nowrap"
                >
                    {label}
                </Body>
            }
        </div>
    );
};

export default Chip;
